import Storage from './Storage';

window.storageLocal = new Storage();
window.storageSession = new Storage({ session: true });
